import useUnlinkFolderEntryFromEvent from '@/api/mutations/scheduledEvent/useUnlinkFolderEntryFromEvent';
import scheduledEventKeys from '@/api/queries/scheduleEvents/keyFactory';
import { Button } from '@payaca/ambrosia';

import UntitledIcon from '@payaca/untitled-icons';
import { useQueryClient } from '@tanstack/react-query';

interface Props {
  folderEntry: {
    id: string;
    name: string;
  };
  scheduledEventId: string;
  onClick?: () => void;
}

const FolderEntryItem = ({ folderEntry, scheduledEventId, onClick }: Props) => {
  const queryClient = useQueryClient();
  const { mutate } = useUnlinkFolderEntryFromEvent({
    eventId: scheduledEventId,
  });

  const handleUnlink = () => {
    mutate(
      {
        folderEntryId: folderEntry.id,
        eventId: scheduledEventId,
      },
      {
        onSuccess: () => {
          void queryClient.invalidateQueries(
            scheduledEventKeys.scheduledEvent(scheduledEventId) as any
          );
        },
      }
    );
  };

  return (
    <div className="p-2 relative bg-blue-400/10 flex items-center flex-col gap-2 rounded-md typography:prose">
      <button
        className="bg-transparent cursor-pointer outline-none w-full p-0"
        onClick={onClick}
      >
        <UntitledIcon name={'file-04'} className="h-auto w-12" />
        <p className="m-0 px-1 w-full text-center text-sm truncate supporting-body">
          {folderEntry.name}
        </p>
      </button>

      <Button
        colour={'grey'}
        className="w-5 h-5 p-0 rounded-full absolute top-2 right-2 "
        onClick={handleUnlink}
      >
        <UntitledIcon name={'x.3'} className="w-5" />
      </Button>
    </div>
  );
};

export default FolderEntryItem;
